import React, {PropTypes} from "react";
import Banner from "../../components/common/Banner";
import Navigation from "../../components/common/Navigation";
import Footer from "../../components/common/utils/Footer";
import {connect} from 'react-redux';
import toastr from 'toastr';
import axios from 'axios';
import FeedbackContainer from './feedbackContainer';
import FeedbackSubmit from './feedbackSubmit';

class FeedbackHome extends React.Component {

  constructor(props) {
    super(props);
    this.state={
      banner: "Feedback",
      options: [],
      questions: [],
      isHidden: true,
      smileyActive: false,
      smileyId: 0,
      smileyValue: null
    }
    this.intializeEvents();
    this.changeBanner = this.changeBanner.bind(this);
    this.onSmileyChange = this.onSmileyChange.bind(this);
  }

  intializeEvents() {
    this.handleSubmit = this.handleSubmit.bind(this);
    this.toggleHidden = this.toggleHidden.bind(this);
  }

  toggleHidden () {
    this.setState({
      isHidden: !this.state.isHidden
    })
  }
  onSmileyChange(object)
  {
    console.log(object);
    if(this.state.smileyId==object.id)
      this.setState({smileyActive: false,smileyId: 0});
    else
      this.setState({smileyActive: true,smileyId: object.id,smileyValue: object.value });

  }

  componentDidMount(){
    //Check if feedback already exists
    let apiUrl0 = process.env.REQ_URL +'/feedback/getUserFeedback';

    axios.get(apiUrl0, {withCredentials: true}).then((response)=> {

     console.log(response.data);
     let feedbackResponse = response.data.data;
      if(feedbackResponse.feedbackExists);
       // this.setState({isHidden: false})
      // response = response.data.data.map((node)=> {
      //   return convert(node);
    });

    //Get all questions from api
    let apiUrl = process.env.REQ_URL +'/feedback/getAllQuestions';

    axios.get(apiUrl, {withCredentials: true}).then((response)=> {

      if(response.data && response.data.data){
        this.setState({questions:response.data.data})
      }
      // response = response.data.data.map((node)=> {
      //   return convert(node);
    });

  }

  handleSubmit (event) {
    console.log("Submitting ");
    event.preventDefault();
    let inputValues = this.getAllInputs(event.target);
    console.log(inputValues);
    if(inputValues==null)
      toastr.error("Form not completely filled");
    let formObject = {
       'answerList': inputValues
    }

    console.log(formObject);

    let apiUrl = process.env.REQ_URL +'/feedback/saveFeedback';

    axios.post(apiUrl, formObject, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
         this.toggleHidden();
          console.log(response);

    }).catch((err)=> {
      console.log("sorry feedback has not submitted");
    });
  }

  getAllInputs(form) {
    let inputElements = form.elements;
    let inputValues = [];
    for (let key in inputElements){
      if (Object.prototype.hasOwnProperty.call(inputElements, key)) {
        console.log(inputElements);
        let input = inputElements[key];
        if (!input.value || !input.name ) continue;
        if (input.type === 'radio') {
          if (input.checked) {
            inputValues.push({questionId:input.getAttribute('data-questionId'),answer:input.value,answerId:input.getAttribute('data-questionId')});
          }
        }
        else if (input.type === 'checkbox') {

          if (input.checked) {
            if (inputValues[input.name]) {
              inputValues[input.name].push(input.value);
            }
            else {
              inputValues[input.name] = [input.value];
            }
          }
        }
        else {
          console.log("***************");
          console.log(input.getAttribute('required'));
          inputValues.push({questionId:input.getAttribute('data-questionId'),answer:input.value,answerId:0});
        }
      }
    }
    inputValues.push({questionId: 1,answer: this.state.smileyValue,answerId: this.state.smileyId});

    return inputValues;
  }

  changeBanner(text)
  {
    this.setState({banner: text})
  }

  render() {
    console.log(this.state.questions)
    return (<div>
        <Banner name={this.state.banner} />
        <div className="container">
          <div className="wrapper-1">
            <div className="row clearfix">
              <div className="col-xs-12">
                <div id="tab_content">
                  <div className="tab-content responsive" style={{padding: 0}}>
                    <div className="row clearfix feedBack">
                     <form name="feedback-form" onSubmit={this.handleSubmit}>

                        {this.state.isHidden &&  <FeedbackContainer
                          onSmileyChange = {this.onSmileyChange}
                          smileyActive={this.state.smileyActive}
                          smileyId={this.state.smileyId}
                          inputs={ this.state.questions } />}

                      </form>

                        {!this.state.isHidden && <FeedbackSubmit disable = {this.state.smileyActive}/>}

                      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer/>
      </div>
    );
  }
}

export default (FeedbackHome);





/** WEBPACK FOOTER **
 ** ./src/feature/feedback/feedbackHome.js
 **/